var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViasprincipais(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C27803"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.92 13.01C26.72 12.42 26.16 12 25.5 12H14.5C13.84 12 13.29 12.42 13.08 13.01L11 19V27C11 27.55 11.45 28 12 28H13C13.55 28 14 27.55 14 27V26H26V27C26 27.55 26.45 28 27 28H28C28.55 28 29 27.55 29 27V19L26.92 13.01ZM14.5 23C13.67 23 13 22.33 13 21.5C13 20.67 13.67 20 14.5 20C15.33 20 16 20.67 16 21.5C16 22.33 15.33 23 14.5 23ZM25.5 23C24.67 23 24 22.33 24 21.5C24 20.67 24.67 20 25.5 20C26.33 20 27 20.67 27 21.5C27 22.33 26.33 23 25.5 23ZM13 18L14.5 13.5H25.5L27 18H13Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViasprincipais);
export default __webpack_public_path__ + "static/media/viasprincipais.1353462a300ba38a85ca8271b5c1cf41.svg";
export { ForwardRef as ReactComponent };